<script setup>
import {useModalsStore} from '@/stores/modals'

// Define Props
const props = defineProps({
    viewId: String,
})

const modalsStore = useModalsStore()

// Methods
const openModal = () => {
    modalsStore.show({
        componentName: 'ListingColumnsModal',
        obj: {
            viewId: props.viewId
        }
    })
}
</script>

<template>
    <button class="d-flex align-items-center" type="button" @click="openModal">
        <i class="me-2 bi-list-columns-reverse"/>
        Columns
    </button>
</template>